import File from "@/scripts/models/file.model";
export default class CampaignSSO {

    constructor() {
        this.campaignId = 0;
        this.tenantId = 0;
        this.clientId = '';
        this.clientSecret = '';
        this.urlMetaData = '';
        this.buttonText = '';
        this.addEmployee = false;
        this.overrideDocument = false;
        this.isItauSSO = false;
        this.file = new File();
    }
}